export class registerNotificationModel {
  user_id: string = null;
  device_id: string = null;
  reg_token: string = null;
  device: string = null;
  type: string = null;
  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}

export class unregisterNotificationModel {
  user_id: string = null;
  device_id: string = null;
  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}